export const OnlineStudyBrand = 'Nettstudier';

export const SingleSubject = 'Enkeltemne';

export const VocationalSchoolBrand = 'Fagskole';

export const CampusBrand = 'Stedsbasert';

export const SchoolName = 'Høyskolen Kristiania';
